/*@ngInject*/
const OptionGroupMultiSelectController = function ($rootScope, $scope, $element, localization, coreConstant, configurationConstant) {

    $element.addClass('optionGroupMultiSelect');

    localization.getTranslationByKey('optionGroupMultiSelect').then(function (translations) {

        this.init = function () {
            if (_.isNil(this.value)) {
                this.value = '';
            }

                this.placeholder = _.isNil(this.defaultPromptValue) ? _.get(translations, 'placeholder') : this.defaultPromptValue;

            this.initItemsList(this.value);
        };

        this.initItemsList = function (selectedValue) {
            this.itemsList = _.map(_.keys(this.values), function (key) {
                return {
                    name: key,
                    value: this.values[key]
                };
            }.bind(this));
        };

        this.buildTooltip = function (value) {
            this.tooltip = '';
            if (!_.isNil(value)) {
                if (value.length > 45) {
                    this.tooltip = value;
                }
            }
        };

        this.$onChanges = function (changes) {
            if (!_.isNil(changes.values)) {
                this.init();
            }
        };

        $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
            if (this.name === itemName) {
                var tempItemList = _.filter(this.itemsList, function (item) {
                        return item.selected;
                    }),
                    values = _.map(tempItemList, 'value');
                values = _.join(values, this.valueDelimiter);
                if (this.value !== values) {
                    this.value = values;

                    $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
                        name: this.name,
                        value: this.value
                    });
                }
            }
        }.bind(this));

        $scope.$on(coreConstant.event.MULTI_SELECT_BUTTON_LABEL_UPDATED, function (event, itemName, buttonLabel) {
            if (this.name === itemName) {
                this.buildTooltip(buttonLabel);
            }
        }.bind(this));

        this.init();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('optionGroupMultiSelectController', OptionGroupMultiSelectController);
